<!--
 * @Author: lishiqiao
 * @Date: 2022-01-13 14:54:51
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-12 16:57:25
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <!-- 公司 -->
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 选择日期年月日 -->
        <div class="page-search-date">
          <div class="page-search-item date-selection-box">
            <span @click="params.type = 'Y'" :class="[params.type == 'Y' ? 'active-date' : '']">年</span>
            <span @click="params.type = 'M'" :class="[params.type == 'M' ? 'active-date' : '']">月</span>
          </div>
          <div class="page-search-item" v-show="params.type === 'Y'">
            <label>年份&nbsp;:</label>
            <el-date-picker value-format="yyyy" v-model="params.boxFy" type="year" placeholder="请选择年份">
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.type === 'M'">
            <label>月份区间&nbsp;:</label>
            <el-date-picker v-model="monthRange" value-format="yyyy-MM" @change="monthChange" type="monthrange"
              range-separator="~" start-placeholder="开始月份" end-placeholder="结束月份">
              >
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>各分子公司客户应收汇总表</div>
        <div>单位 : {{ unitName }}</div>
        <!-- 年报表 -->
        <div v-if="params.type == 'Y'">年份 : {{ showYear }}年</div>
        <!-- 月报表 -->
        <div v-if="params.type == 'M'">
          月份 :
          {{ showStartDate }}-{{ showEndDate }}
        </div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="switch-table" @click="switchTable">明细</span>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位"> </el-table-column>
        <el-table-column prop="receiveStart" label="期初应收余额">
        </el-table-column>
        <el-table-column prop="saleNumber" label="本期销售数量">
        </el-table-column>
        <el-table-column prop="saleMoney" label="本期销售金额">
        </el-table-column>
        <el-table-column prop="receiveMoney" label="本期收款金额">
        </el-table-column>
        <el-table-column prop="receiveMoneyF" label="本期费用处理金额">
        </el-table-column>
        <el-table-column prop="receiveEnd" label="期末余额"> </el-table-column>
        <el-table-column prop="cumulativeRecoveryRate" label="累计回收率">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import service from "../ym-sales-service";
import Page from "@/utils/methods/page";
export default {
  name: "customer-summary",
  data() {
    return {
      monthRange: [],
      PageDisplay: true,
      unitName: "", // 单位名称
      showYear: "", // 显示的年份
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        rootId: "",
        orgId: "",
        breedTypeClass: "egg",
        isTotal: true,
        boxFy: localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString(),
        type: "Y",
        startDate: "",
        endDate: "",
      },
      exportParams: {}, // 导出参数
      tableData: [],
      companyList: [], // 公司列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.rootId = localStorage.getItem("rootId");
    this.getCompanyList(); // 获取公司列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 切换明细表
    switchTable() {
      this.$emit("getPageType", "detail");
    },

    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.startDate = val[0];
      this.params.endDate = val[1];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 11:01:53
     * @description: 获取公司列表
     * @param {*}
     */
    getCompanyList() {
      service
        .getSummaryCompanyList(this.params.rootId)
        .then((res) => {
          if (res.code == "0000") {
            this.companyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 初始化时间
    initTime() {
      this.params.boxFy = null;
      this.params.startDate = null;
      this.params.endDate = null;
      this.monthRange = [];
      if (this.params.type == "Y") {
        this.params.boxFy = localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString();
      }
      if (this.params.type == "M") {
        this.params.startDate = this.$moment().format("YYYY-MM");
        this.params.endDate = this.$moment().format("YYYY-MM");
        this.monthRange.push(this.params.startDate);
        this.monthRange.push(this.params.endDate);
      }
    },

    // 重置
    reset() {
      this.params.orgId = "";
      this.initTime();
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-年-月-日
    showListData() {
      if (this.params.boxFy) {
        this.showYear = this.params.boxFy;
      }
      if (this.params.orgId) {
        this.unitName = this.companyList.filter(
          (item) => item.id == this.params.orgId
        )[0].name;
      } else {
        this.unitName = "恒兴水产养殖事业部";
      }
      if (this.params.type == "M") {
        this.showStartDate = this.$moment(this.params.startDate).format(
          "YYYY年MM月"
        );
        this.showEndDate = this.$moment(this.params.endDate).format(
          "YYYY年MM月"
        );
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 14:48:24
     * @description: 获取育苗汇总分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getCustomersPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 15:46:11
     * @description: 导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "育苗销售概览客户应收汇总";
          this.exportParams.title = "育苗销售概览客户应收汇总";
          service
            .exportCustomersData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    // 监听type年月日变化
    "params.type"(val) {
      this.initTime();
      this.getPageList();
    },
  },
};
</script>

<style></style>